export default __webpack_public_path__ + "static/media/COLLECTIONS.43515bb7.svg";